import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
import { OpsDeviceHealthSchema } from './ops-efem-peripherals-health.schemas.js';
// ========================================
// Provider Ops — Site Anchor Infrastructure Health (Phase 0)
// ========================================
export const SiteAnchorAssignmentStateSchema = z.enum([
    'assigned',
    'unassigned_point',
    'unassigned_hardware',
]);
export const SiteAnchorHealthRowSchema = z.object({
    tenantId: z.string(),
    siteId: z.string(),
    siteName: z.string().nullable().optional(),
    anchorSerialNumber: z.string().nullable().optional(),
    anchorPointId: z.string().nullable().optional(),
    anchorPointLabel: z.string().nullable().optional(),
    floorId: z.string().nullable().optional(),
    floorName: z.string().nullable().optional(),
    tdoaRole: z.string().nullable().optional(),
    assignmentState: SiteAnchorAssignmentStateSchema,
    assigned: z.boolean(),
    online: z.boolean().nullable().optional(),
    lastSeenAt: z.string().nullable().optional(),
    firmwareVersion: z.string().nullable().optional(),
    siteLocationGatewaySerial: z.string().nullable().optional(),
    gatewayConfigSyncHealth: z.string().nullable().optional(),
    gatewayHeartbeatStatus: z.enum(['active', 'stale', 'unknown']).nullable().optional(),
    lastConfigPushVersion: z.string().nullable().optional(),
    topologyWarnings: z.array(z.string()).default([]),
    manufacturerName: z.string().nullable().optional(),
    deviceModel: z.string().nullable().optional(),
    overallHealth: OpsDeviceHealthSchema,
    healthReason: z.string().nullable().optional(),
});
export const SiteAnchorHealthSummarySchema = z.object({
    total: z.number().int().min(0),
    assigned: z.number().int().min(0),
    online: z.number().int().min(0),
    offline: z.number().int().min(0),
    unassignedPoints: z.number().int().min(0),
    unassignedHardware: z.number().int().min(0),
    healthy: z.number().int().min(0),
    degraded: z.number().int().min(0),
    unhealthy: z.number().int().min(0),
    unknown: z.number().int().min(0),
    notApplicable: z.number().int().min(0),
});
export const SiteAnchorHealthListQuerySchema = z.object({
    tenantId: z.string().optional(),
    siteId: z.string().optional(),
    assignmentState: SiteAnchorAssignmentStateSchema.optional(),
    overallHealth: OpsDeviceHealthSchema.optional(),
    online: z.enum(['true', 'false']).optional(),
    search: z.string().max(100).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const SiteAnchorHealthListResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        anchors: z.array(SiteAnchorHealthRowSchema),
        summary: SiteAnchorHealthSummarySchema,
        nextCursor: z.string().nullable().optional(),
        count: z.number().int().min(0),
    }),
});
/** Tenant-scoped anchor health list (tenantId comes from auth, not query). */
export const TenantSiteAnchorHealthListQuerySchema = SiteAnchorHealthListQuerySchema.omit({ tenantId: true });
//# sourceMappingURL=ops-site-anchor-health.schemas.js.map